<script lang="ts">
  import { onMount } from "svelte";
  import ActivityCategoryDropdown from "../../components/Business/ActivityCategoryDropdown.svelte";
  import DossierTypeDropdown from "../../components/Business/DossierTypeDropdown.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import GlobalErrors from "../../components/GlobalErrors.svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import Table from "../../components/Table/Table.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import type { IDropdownItem } from "../../services/DTO/dropdown-item";
  import { activityTypeDtoFields } from "../../utils/TableFields/activity-type-dto.fields";
  import {
    applyUserRevenue,
    dossierActivities,
    editing,
    init,
    loadActivityTypes,
    loading,
    onCreate,
    onDelete,
    onEdit,
    onPageChange,
    pagination,
    record,
    records,
    save,
    selectedActivityCategory,
    selectedDossierType,
  } from "./settings-activity-types.store";

  $: canSubmit = $record != null && !!$record.description;

  $: isNew = $record != null && $record.oid === 0;

  async function onSubmit() {
    await save();
    editing.set(false);
    record.set(null);
  }

  function onCancel() {
    editing.set(false);
    record.set(null);
  }

  async function onActivityCategorySelect(event: CustomEvent) {
    if (event != null && event.detail != null) {
      let item: IDropdownItem = event.detail;
      selectedActivityCategory.set(item.oid);
    } else {
      selectedActivityCategory.set(0);
    }
    loadActivityTypes();
  }

  async function onDossierTypeSelect(event: CustomEvent) {
    if (event != null && event.detail != null) {
      let item: IDropdownItem = event.detail;
      selectedDossierType.set(item.oid);
    } else {
      selectedDossierType.set(0);
    }
    loadActivityTypes();
  }

  onMount(init);
</script>

{#if $editing === false}
  <SearchHeader
    entitySingular="tipo attività"
    entityPlural="tipi attività"
    searchPlaceholder="cerca per descrizione"
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    searchFieldVisible={false}
  >
    <div class="level-item" slot="search">
      <div class="field" style="margin-right:10px">
        <p class="control" style="min-width:300px">
          <ActivityCategoryDropdown
            name=""
            filterVisible={true}
            clearVisible={true}
            placeholder="categoria attività"
            on:select={onActivityCategorySelect}
            on:clear={onActivityCategorySelect}
            value={$selectedActivityCategory}
          />
        </p>
      </div>

      {#if $dossierActivities}
        <div class="field">
          <p class="control" style="min-width:300px">
            <DossierTypeDropdown
              name=""
              filterVisible={true}
              clearVisible={true}
              placeholder="causale pratica"
              on:select={onDossierTypeSelect}
              on:clear={onDossierTypeSelect}
              value={$selectedDossierType}
            />
          </p>
        </div>
        <div class="field" style="margin-left:2rem;">
          <p class="control">
            {#if $selectedDossierType == 0}
              <i
                >vengono visualizzati i tipi di attività <b>generici</b> (comuni
                a tutti i tipi pratica)</i
              >
            {:else}
              <i
                >vengono visualizzati i tipi di attività legati al <b
                  >tipo pratica selezionato</b
                ></i
              >
            {/if}
          </p>
        </div>
      {/if}
    </div>
  </SearchHeader>

  <GlobalErrors errors={[]} />

  <div style="padding-bottom: 2rem;">
    <Table
      loading={$loading}
      fields={activityTypeDtoFields}
      records={$records}
      pagination={$pagination}
      createEnabled={true}
      editEnabled={true}
      deleteEnabled={true}
      on:create={(_) => onCreate()}
      on:edit={(e) => onEdit(e.detail)}
      on:delete={(e) => onDelete(e.detail)}
      on:pageChange={(e) => onPageChange(e.detail)}
    />
  </div>
{:else if $record != null}
  <FormLayout on:submit={onSubmit} on:cancel={onCancel} {canSubmit} {isNew}>
    <FormField usageHelp="codice numerico">
      <NumberInput
        name="Codice"
        placeholder="codice"
        required={true}
        bind:value={$record.numCode}
      />
    </FormField>

    <FormField usageHelp="descrizione visibile (200 caratteri)">
      <Input
        name="Descrizione"
        placeholder="descrizione"
        required={true}
        maxlength={200}
        bind:value={$record.description}
      />
    </FormField>

    <FormField usageHelp="categoria attività">
      <ActivityCategoryDropdown
        name="Categoria Attività"
        required={true}
        bind:value={$record.activityCategoryId}
      />
    </FormField>

    <FormField
      usageHelp={$applyUserRevenue
        ? "ricavo orario (disabilitato poiché è abilitato il ricavo utente)"
        : "ricavo orario"}
    >
      <NumberInput
        name="Ricavo orario"
        placeholder="ricavo orario"
        required={!$applyUserRevenue}
        disabled={$applyUserRevenue}
        bind:value={$record.hourlyRevenue}
      />
    </FormField>
  </FormLayout>
{/if}
